import { __ } from '@wordpress/i18n';
import { twMerge } from 'tailwind-merge';
import { Slot } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { SimpleInput } from '@getdokan/dokan-ui';
import { QUOTE_LIST_SLOTS } from '../Common/QuoteListSlot';
import { SearchIcon } from 'lucide-react';

interface SearchBarProps {
    search: string;
    isLoading: boolean;
    className?: string;
    isItemAvailable: boolean;
    setSearch: ( value: string ) => void;
}

const SearchBar = ( {
    search,
    setSearch,
    isLoading,
    className = '',
    isItemAvailable,
}: SearchBarProps ) => {
    const handleSearch = () => {
        if ( search && ! isLoading && isItemAvailable ) {
            setSearch( search );
        }
    };

    return (
        <div className={ twMerge( 'space-x-2', className ) }>
            { /* Before quote list search slot */ }
            <Slot
                name={ QUOTE_LIST_SLOTS.BEFORE_LIST_SEARCH }
                fillProps={ { search, isItemAvailable } }
            />

            <div className="relative flex-grow">
                <SimpleInput
                    value={ search }
                    disabled={ isLoading }
                    addOnRight={
                        <label
                            htmlFor={ 'dokan-quote-list-search' }
                            className={ `flex items-center justify-center` }
                        >
                            <span className="truncate max-w-[20rem] max-h- inline-block">
                                <SearchIcon size={ 20 } />
                            </span>
                        </label>
                    }
                    onChange={ ( e ) => setSearch( e.target.value ) }
                    className={ `bg-white focus:bg-white shadow-none focus:shadow-none text-sm max-w-40 border-tr-0 border-br-0 px-4` }
                    input={ {
                        type: 'text',
                        id: 'dokan-quote-list-search',
                        placeholder: __( 'Search Quotes', 'dokan' ),
                    } }
                />
            </div>

            { /* After quote list search slot */ }
            <Slot
                name={ QUOTE_LIST_SLOTS.AFTER_LIST_SEARCH }
                fillProps={ { search, isItemAvailable } }
            />
        </div>
    );
};

export default SearchBar;
